import React, { createContext, useState} from "react";
import { useContext } from "react";
import {WishlistContext}  from "./Wishlistcontext";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const {isWishlisted,removeFromWishlist} = useContext(WishlistContext);
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => `${item.category}-${item.id}${item.name}` === `${product.category}-${product.id}-${product.name}`);
      if (existing) {
        return prev.map((item) =>
          `${item.category}-${item.id}${item.name}` === `${product.category}-${product.id}-${product.name}`
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    if(isWishlisted(product)){
      // console.log("reached");
      removeFromWishlist(product);
    }
  };

  const removeFromCart = (id) =>
    setCartItems((prev) => prev.filter((item) => item.id !== id));

  const updateQuantity = (id, quantity) => {
    if (quantity < 1) return;
    setCartItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity } : item))
    );
  };

  const clearCart = () => setCartItems([]);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity, // ✅ must include this
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
